import { i18n } from '../utils/I18n.js';

export class AchievementModal {
    constructor(achievementSystem) {
        this.achievementSystem = achievementSystem;
        this.container = null;
        this.init();
    }

    init() {
        this.container = document.createElement('div');
        this.container.id = 'achievementModal';
        this.container.innerHTML = `
            <div class="achievement-modal-content">
                <div class="achievement-header">
                    <div class="achievement-header-title">
                        <span class="trophy-icon">
                            <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                                <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/>
                            </svg>
                        </span>
                        <h2 data-i18n="achievement.title">Achievements</h2>
                    </div>
                    <button class="close-btn" aria-label="Close">
                        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                </div>
                <div class="achievement-stats" id="achievementStats">
                    <!-- Stats will be populated here -->
                </div>
                <div class="achievement-list" id="achievementList">
                    <!-- Achievements will be populated here -->
                </div>
            </div>
        `;

        this.addStyles();
        document.body.appendChild(this.container);

        // Bind close event
        this.container.querySelector('.close-btn').addEventListener('click', () => this.hide());
        this.container.addEventListener('click', (e) => {
            if (e.target === this.container) this.hide();
        });
    }

    addStyles() {
        if (document.getElementById('achievement-modal-styles')) return;

        const style = document.createElement('style');
        style.id = 'achievement-modal-styles';
        style.textContent = `
            @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap');

            #achievementModal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(93, 78, 66, 0.6);
                backdrop-filter: blur(8px);
                -webkit-backdrop-filter: blur(8px);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 3000;
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.3s ease;
            }

            #achievementModal.visible {
                opacity: 1;
                pointer-events: auto;
            }

            .achievement-modal-content {
                font-family: 'Quicksand', sans-serif;
                background: linear-gradient(180deg, #FDF6EC 0%, #FAF0E4 100%);
                width: 560px;
                max-width: 92%;
                max-height: 85vh;
                border-radius: 24px;
                box-shadow: 0 20px 60px rgba(93, 78, 66, 0.25);
                display: flex;
                flex-direction: column;
                overflow: hidden;
                border: 1px solid rgba(201, 167, 125, 0.2);
                transform: scale(0.9) translateY(20px);
                transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            }

            #achievementModal.visible .achievement-modal-content {
                transform: scale(1) translateY(0);
            }

            .achievement-header {
                padding: 24px 28px;
                background: linear-gradient(135deg, #E8A598 0%, #C9A77D 100%);
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .achievement-header-title {
                display: flex;
                align-items: center;
                gap: 12px;
            }

            .trophy-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #FFF;
                filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
            }

            .achievement-header h2 {
                margin: 0;
                color: #FFF;
                font-size: 1.5rem;
                font-weight: 700;
                text-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }

            .close-btn {
                background: rgba(255, 255, 255, 0.2);
                border: none;
                color: white;
                width: 40px;
                height: 40px;
                border-radius: 12px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
            }

            .close-btn:hover {
                background: rgba(255, 255, 255, 0.3);
                transform: scale(1.05);
            }

            .achievement-stats {
                padding: 20px 28px;
                background: rgba(201, 167, 125, 0.1);
                display: flex;
                justify-content: space-around;
                border-bottom: 1px solid rgba(201, 167, 125, 0.15);
            }

            .stat-box {
                text-align: center;
            }

            .stat-value {
                font-size: 1.8rem;
                font-weight: 700;
                color: #A67C52;
                line-height: 1.2;
            }

            .stat-label {
                font-size: 0.85rem;
                color: #8B7355;
                margin-top: 4px;
            }

            .achievement-list {
                padding: 20px 28px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                gap: 14px;
                flex: 1;
            }

            .achievement-list::-webkit-scrollbar {
                width: 6px;
            }

            .achievement-list::-webkit-scrollbar-track {
                background: rgba(201, 167, 125, 0.1);
                border-radius: 3px;
            }

            .achievement-list::-webkit-scrollbar-thumb {
                background: rgba(201, 167, 125, 0.4);
                border-radius: 3px;
            }

            .achievement-list::-webkit-scrollbar-thumb:hover {
                background: rgba(201, 167, 125, 0.6);
            }

            .achievement-item {
                display: flex;
                align-items: center;
                padding: 16px 18px;
                background: #FFFFFF;
                border-radius: 16px;
                border: 1px solid rgba(201, 167, 125, 0.15);
                box-shadow: 0 2px 8px rgba(139, 115, 85, 0.06);
                transition: all 0.3s ease;
            }

            .achievement-item:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 16px rgba(139, 115, 85, 0.12);
            }

            .achievement-item.unlocked {
                background: linear-gradient(135deg, rgba(157, 192, 163, 0.15) 0%, rgba(255, 255, 255, 1) 100%);
                border-color: rgba(157, 192, 163, 0.4);
            }

            .achievement-item.locked {
                opacity: 0.65;
            }

            .achievement-item.locked .achievement-icon-wrapper {
                filter: grayscale(1);
                opacity: 0.5;
            }

            .achievement-icon-wrapper {
                width: 56px;
                height: 56px;
                background: linear-gradient(135deg, #FAF0E4, #FDF6EC);
                border-radius: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 1.8rem;
                margin-right: 16px;
                flex-shrink: 0;
                box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
            }

            .achievement-item.unlocked .achievement-icon-wrapper {
                background: linear-gradient(135deg, #F6D365, #E8A598);
                box-shadow: 0 4px 12px rgba(232, 165, 152, 0.3);
            }

            .achievement-details {
                flex: 1;
                min-width: 0;
            }

            .achievement-title {
                font-weight: 700;
                color: #5D4E42;
                margin-bottom: 4px;
                font-size: 1.05rem;
            }

            .achievement-item.unlocked .achievement-title {
                color: #5A8F66;
            }

            .achievement-desc {
                font-size: 0.9rem;
                color: #8B7355;
                line-height: 1.4;
            }

            .achievement-date {
                font-size: 0.8rem;
                color: #B5A08E;
                margin-top: 6px;
                display: flex;
                align-items: center;
                gap: 4px;
            }

            .achievement-date svg {
                width: 14px;
                height: 14px;
            }

            .achievement-badge {
                margin-left: auto;
                padding: 6px 12px;
                border-radius: 20px;
                font-size: 0.75rem;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.5px;
            }

            .achievement-item.unlocked .achievement-badge {
                background: rgba(157, 192, 163, 0.2);
                color: #5A8F66;
            }

            .achievement-item.locked .achievement-badge {
                background: rgba(181, 160, 142, 0.2);
                color: #8B7355;
            }

            @media (max-width: 600px) {
                .achievement-modal-content {
                    max-height: 90vh;
                    border-radius: 20px 20px 0 0;
                    margin-top: auto;
                }

                .achievement-header {
                    padding: 20px;
                }

                .achievement-stats {
                    padding: 16px 20px;
                }

                .achievement-list {
                    padding: 16px 20px;
                }

                .achievement-icon-wrapper {
                    width: 48px;
                    height: 48px;
                    font-size: 1.5rem;
                }
            }
        `;
        document.head.appendChild(style);
    }

    renderStats() {
        const statsContainer = document.getElementById('achievementStats');
        const achievements = this.achievementSystem.getAchievements();
        const stats = this.achievementSystem.getStats();

        const unlockedCount = achievements.filter(a => a.unlocked).length;
        const totalCount = achievements.length;

        statsContainer.innerHTML = `
            <div class="stat-box">
                <div class="stat-value">${unlockedCount}/${totalCount}</div>
                <div class="stat-label">${i18n.t('achievement.unlocked')}</div>
            </div>
            <div class="stat-box">
                <div class="stat-value">${stats.totalWins || 0}</div>
                <div class="stat-label">${i18n.t('achievement.puzzles_completed')}</div>
            </div>
            <div class="stat-box">
                <div class="stat-value">${this.formatTime(stats.fastestWin)}</div>
                <div class="stat-label">${i18n.t('achievement.best_time')}</div>
            </div>
        `;
    }

    formatTime(seconds) {
        if (!seconds || seconds === Infinity) return '--:--';
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    }

    renderList() {
        const list = document.getElementById('achievementList');
        const achievements = this.achievementSystem.getAchievements();

        // Sort: unlocked first, then by unlock time (recent first)
        const sorted = [...achievements].sort((a, b) => {
            if (a.unlocked && !b.unlocked) return -1;
            if (!a.unlocked && b.unlocked) return 1;
            if (a.unlocked && b.unlocked) {
                return (b.unlockedAt || 0) - (a.unlockedAt || 0);
            }
            return 0;
        });

        list.innerHTML = sorted.map(ach => {
            const statusClass = ach.unlocked ? 'unlocked' : 'locked';
            const dateStr = ach.unlockedAt
                ? new Date(ach.unlockedAt).toLocaleDateString('zh-CN', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                })
                : '';

            return `
                <div class="achievement-item ${statusClass}">
                    <div class="achievement-icon-wrapper">
                        ${ach.unlocked ? ach.icon : '?'}
                    </div>
                    <div class="achievement-details">
                        <div class="achievement-title">${ach.unlocked ? ach.title : '???'}</div>
                        <div class="achievement-desc">${ach.description}</div>
                        ${ach.unlocked ? `
                            <div class="achievement-date">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                                </svg>
                                ${dateStr}
                            </div>
                        ` : ''}
                    </div>
                    <span class="achievement-badge">${ach.unlocked ? i18n.t('achievement.badge_unlocked') : i18n.t('achievement.badge_locked')}</span>
                </div>
            `;
        }).join('');
    }

    show() {
        this.renderStats();
        this.renderList();
        this.container.classList.add('visible');
        i18n.applyTranslations();
    }

    hide() {
        this.container.classList.remove('visible');
    }
}
